import { useRef, useEffect, useState } from 'react'

import { faBell } from '@fortawesome/pro-light-svg-icons/faBell'
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Icon from '@space-lib/components/icon'
import { Actions, Entities } from '@space-lib/datahub'
import '@hotmart/cosmos/dist/dropdown'
import { useMediaQuery } from '@space-lib/hooks'
import { ScreenSizes } from '@space-lib/styles'
import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { useTranslation } from 'react-i18next'

import NotificationsContainer from './components/notificationsContainer'
import { useNotificationCountRequest } from './hooks/useNotificationCountRequest'
import { NotificationsCount } from './styles'

const MAX_NOTIFICATION_COUNT = 99

const Notifications = () => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const itemRef = useRef<HTMLButtonElement>(null)
  const [showNotificationsList, setShowNotificationsList] = useState(false)
  const { t } = useTranslation()
  const { sendDataHubEvent } = useDataHubEvents()
  const notificationCountRequest = useNotificationCountRequest()
  const count = notificationCountRequest.data?.unread || 0

  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.md})`)

  const handleClickOnNotificationsIcon = () => {
    setShowNotificationsList(true)
    const element = document.getElementById('root')

    if (element && isMobile) {
      element.scrollTop = 0
    }

    sendDataHubEvent({
      group: Entities.NOTIFICATIONS,
      name: Actions.CLICK_NOTIFICATIONS_ICON
    })
  }

  useEffect(() => {
    if (dropdownRef.current) {
      const shadowRootDropdown = dropdownRef.current.shadowRoot
      const dropdownElement = shadowRootDropdown?.querySelector(
        '.hot-dropdown__menu'
      ) as HTMLDivElement
      dropdownElement.style.borderColor = 'var(--gray-200)'
    }
  }, [])

  return (
    <hot-dropdown ref={dropdownRef} slot='actions-end' class='hot-dropdocked'>
      <hot-menu-item
        ref={itemRef}
        slot='button'
        class='hot-application--minimized _cursor-pointer'
        onClick={handleClickOnNotificationsIcon}>
        <Icon icon={faBell} className='_text-gray-900 _text-3' />
        <NotificationsCount className='_d-flex _align-items-center _text-1 _rounded-lg _justify-content-center _text-white'>
          {count >= MAX_NOTIFICATION_COUNT ? `+${MAX_NOTIFICATION_COUNT}` : count}
        </NotificationsCount>
      </hot-menu-item>
      <div slot='menu'>
        <hot-dropdown-menu-header class='_p-0'>
          <div className='_d-flex _flex-column'>
            <h2 className='_text-4 _text-gray-800 _font-weight-light _p-4 _mb-0 _d-flex _justify-content-between _align-items-center'>
              <span>{t('notifications.heading')}</span>
              {isMobile && <Icon icon={faXmark} className='_text-3 _text-gray-800' />}
            </h2>
          </div>
        </hot-dropdown-menu-header>
        {showNotificationsList && <NotificationsContainer />}
      </div>
    </hot-dropdown>
  )
}

export default Notifications
